module.exports = __webpack_public_path__ + "static/favicon.d23e3e5f.ico";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/favicon.ico
// module id = 367
// module chunks = 114276838955818